import { Typography } from 'design-system/compat';
import { FormattedMessage } from 'react-intl';
import styles from './CreateMembership.module.css';

const { Title, Text } = Typography;

const Header = ({ messageKey, headingKey }) => {
  return (
    <div className={styles.header}>
      <Title level={2} className={styles.heading}>
        <FormattedMessage id={headingKey} />
      </Title>
      {/* <Text className={styles.subheading}>
        <FormattedMessage id={messageKey} />
      </Text> */}
    </div>
  );
};

export default Header;
